import React from "react";
import {Outlet} from "react-router-dom";

export interface RegistrationLayoutProps {

}

const RegistrationLayout = (props: RegistrationLayoutProps) => {

    return (
        <div className="registration-layout">
            <Outlet/>
        </div>
    );
}


export default RegistrationLayout;




